/**
 * Servicio para manejar iconos dinámicos según el idioma
 */
import configService from './configService.js';
import fileService from './fileService.js';

class IconService {
  constructor() {
    this.currentLanguage = 'es';
    this.defaultIcon = '/images/ldda_logo.png';
  }

  /**
   * Cambia el favicon según el idioma
   */
  async updateFavicon(language) {
    try {
      // Obtener el logo configurado para este idioma
      const logoPath = await this.getLogoForLanguage(language);
      
      // Actualizar favicon
      this.setFavicon(logoPath);
      
      // Actualizar apple-touch-icon si existe
      this.setAppleTouchIcon(logoPath);
      
      this.currentLanguage = language;
      console.log(`✅ Favicon actualizado para idioma: ${language} -> ${logoPath}`);
      
    } catch (error) {
      console.warn('⚠️ Error actualizando favicon:', error);
      // Fallback al icono por defecto
      this.setFavicon(this.defaultIcon);
    }
  }

  /**
   * Obtiene el logo configurado para un idioma específico
   */
  async getLogoForLanguage(language) {
    try {
      // Intentar obtener logo_192 específico del idioma desde configService
      let logoPath = null;
      
      try {
        logoPath = await configService.getConfigText('general.logo_192', language, this.defaultIcon);
      } catch (error) {
        console.warn(`⚠️ Error obteniendo logo_192 para ${language}:`, error);
      }
      
      return fileService.getRelativeFileUrl(logoPath);
    } catch (error) {
      console.warn(`⚠️ Error obteniendo logo para idioma ${language}:`, error);
      return this.defaultIcon;
    }
  }
  
  /**
   * Establece el favicon
   */
  setFavicon(iconPath) {
    // Remover favicon existente
    const existingFavicon = document.querySelector('link[rel="icon"]');
    if (existingFavicon) {
      existingFavicon.remove();
    }

    // Crear nuevo favicon
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/png';
    favicon.href = iconPath;
    
    document.head.appendChild(favicon);
  }

  /**
   * Establece el apple-touch-icon
   */
  setAppleTouchIcon(iconPath) {
    // Para apple-touch-icon, usar directamente el logo_192 si es el path de 192
    let highResIcon = iconPath;
    
    // Si es un logo de 192, usarlo directamente; si no, intentar encontrar la versión de 192
    if (!iconPath.includes('_192')) {
      highResIcon = iconPath.replace('.png', '_192.png');
    }
    
    // Remover apple-touch-icon existente
    const existingAppleIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (existingAppleIcon) {
      existingAppleIcon.remove();
    }

    // Crear nuevo apple-touch-icon
    const appleIcon = document.createElement('link');
    appleIcon.rel = 'apple-touch-icon';
    appleIcon.sizes = '192x192';
    appleIcon.href = highResIcon;
    
    document.head.appendChild(appleIcon);
  }

  /**
   * Inicializa el servicio con el idioma por defecto
   */
  async init(defaultLanguage = 'es') {
    await this.updateFavicon(defaultLanguage);
  }
}

// Instancia global
const iconService = new IconService();

// Exportar para uso en módulos
export default iconService;

// También disponible globalmente
window.iconService = iconService;
